import { Controller } from "@hotwired/stimulus"

const MESSAGE = "You have unsaved changes. Discard them and leave this page?"

export default class extends Controller {
  connect() {
    this.allowLeave = false
    this.initialSnapshots = new Map()
    this.boundBeforeUnload = this.beforeUnload.bind(this)
    this.boundGuardClick = this.guardClick.bind(this)
    this.boundAllowSubmit = this.allowSubmit.bind(this)

    this.element.addEventListener("click", this.boundGuardClick)
    this.element.addEventListener("submit", this.boundAllowSubmit)
    window.addEventListener("beforeunload", this.boundBeforeUnload)

    // Wait a frame so searchable selects and similar widgets finish rewriting
    // hidden inputs; those mutations are not user edits.
    requestAnimationFrame(() => this.snapshotForms())
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundGuardClick)
    this.element.removeEventListener("submit", this.boundAllowSubmit)
    window.removeEventListener("beforeunload", this.boundBeforeUnload)
  }

  snapshotForms() {
    this.initialSnapshots = new Map()
    this.element.querySelectorAll("form").forEach((form) => {
      this.initialSnapshots.set(form, this.serialize(form))
    })
  }

  dirty() {
    return [...this.element.querySelectorAll("form")].some((form) => {
      const initial = this.initialSnapshots.get(form)
      if (initial == null) return false
      return this.serialize(form) !== initial
    })
  }

  allowSubmit() {
    this.allowLeave = true
  }

  guardClick(event) {
    const link = event.target.closest("a[href]")
    if (!link || link.target === "_blank" || event.defaultPrevented || event.metaKey || event.ctrlKey) return
    if (!this.leavesSettings(link) && !this.switchesDestination(link)) return
    if (!this.dirty() || this.allowLeave) return

    event.preventDefault()
    if (window.confirm(MESSAGE)) {
      this.allowLeave = true
      link.click()
    }
  }

  beforeUnload(event) {
    if (this.allowLeave || !this.dirty()) return
    event.preventDefault()
    event.returnValue = ""
  }

  switchesDestination(link) {
    return link.classList.contains("settings-nav-destination")
  }

  leavesSettings(link) {
    if (link.classList.contains("settings-nav-destination")) return false
    try {
      const url = new URL(link.href, window.location.origin)
      return url.origin === window.location.origin && !url.pathname.startsWith("/settings")
    } catch (_error) {
      return false
    }
  }

  serialize(form) {
    return new URLSearchParams(new FormData(form)).toString()
  }
}
